// @flow strict

import * as React from 'react';
import SaveSessionTrackingContext from './SaveSessionTrackingContext';
import useSessionState from './useSessionState';

export type SaveSessionTracking = {|
  sessionUuid: string,
  sessionOrder: number,
|};

type Props = {|
  children: React.Node,
|};

/**
 * Holds the state used for the SaveSessionTrackingContext Provider and exposes
 * the save session as well as some functions to manipulate the state.
 */
const SaveSessionProvider = ({ children }: Props) => {
  const state = useSessionState();
  return (
    <SaveSessionTrackingContext.Provider value={state}>
      {children}
    </SaveSessionTrackingContext.Provider>
  );
};

export default SaveSessionProvider;
